/* PLP Model / Studio view toggle + 50/50 A/B test. See snippets/plp-view-toggle.liquid */
(function () {
  if (window.__plpViewToggle) return;
  window.__plpViewToggle = true;

  var root = document.documentElement;
  var TEST = 'plp_view_toggle';
  var ab = window.linziPlpAb || { group: 'excluded', live: false };
  var inTest = ab.live && (ab.group === 'variant' || ab.group === 'control');

  function track(name, extra) {
    var data = { ab_test: TEST, ab_group: ab.group };
    if (extra) for (var k in extra) data[k] = extra[k];
    try {
      window.dataLayer = window.dataLayer || [];
      var o = { event: name };
      for (var j in data) o[j] = data[j];
      window.dataLayer.push(o);
    } catch (e) {}
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }

  /* Test bookkeeping: report the group once per session and tag the cart so orders carry the group. */
  if (inTest) {
    try {
      var sentKey = 'linzi:ab:' + TEST + ':sent';
      if (sessionStorage.getItem(sentKey) !== ab.group) {
        track('ab_assignment');
        sessionStorage.setItem(sentKey, ab.group);
      }
    } catch (e) {}

    try {
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var attr = 'ab_' + TEST;
      fetch(base + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && cart.attributes && cart.attributes[attr] === ab.group) return;
          var attrs = {};
          attrs[attr] = ab.group;
          return fetch(base + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: attrs })
          });
        })
        .catch(function () {});
    } catch (e) {}
  }

  /* Everything below only runs for the variant group. Control and excluded visitors see the normal grid. */
  if (!root.classList.contains('plp-ab--variant')) return;

  var KEY = 'linzi:plpView';

  function read() {
    try { return localStorage.getItem(KEY) === 'studio' ? 'studio' : 'model'; } catch (e) { return 'model'; }
  }
  function save(v) {
    try { localStorage.setItem(KEY, v); } catch (e) {}
  }

  var view = read();

  function isTouch() {
    return root.classList.contains('supports-touch');
  }

  function syncButtons() {
    var buttons = document.querySelectorAll('[data-plp-view]');
    for (var i = 0; i < buttons.length; i++) {
      var pressed = String(buttons[i].getAttribute('data-plp-view') === view);
      if (buttons[i].getAttribute('aria-pressed') !== pressed) buttons[i].setAttribute('aria-pressed', pressed);
    }
  }

  /* On touch devices the card image is a swipe slider: start it on image 2 (studio) or image 1 (model). */
  function syncSliders(force) {
    if (!isTouch()) return;
    var sliders = document.querySelectorAll('.product-item [data-hover-slider]');
    for (var i = 0; i < sliders.length; i++) {
      var sl = sliders[i];
      if (!force && sl.getAttribute('data-plp-synced') === view) continue;
      var card = sl.closest('.product-item');
      if (!card || !card.querySelector('[data-studio-image]')) continue;
      var slides = sl.querySelectorAll('.product-item__bg__slide');
      var target = slides[view === 'studio' ? 1 : 0];
      if (!target || !slides[0]) continue;
      sl.setAttribute('data-plp-synced', view);
      sl.scrollLeft = target.offsetLeft - slides[0].offsetLeft;
    }
  }

  function apply() {
    root.classList.toggle('plp-view--studio', view === 'studio');
    syncButtons();
    syncSliders(true);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-plp-view]');
    if (btn) {
      e.preventDefault();
      var next = btn.getAttribute('data-plp-view') === 'studio' ? 'studio' : 'model';
      var changed = next !== view;
      view = next;
      save(view);
      apply();
      if (changed) track('plp_view_change', { view: view });
      try { window.dispatchEvent(new CustomEvent('plp:view-change', { detail: { view: view } })); } catch (err) {}
      return;
    }

    /* Colour sibling swatch clicked: the theme swaps the card's images, so swap the studio image too. */
    var swatch = e.target.closest && e.target.closest('tooltip-component[data-all-images]');
    if (swatch) {
      setTimeout(function () {
        var card = swatch.closest('.grid-item');
        var img = card && card.querySelector('[data-studio-image] img');
        if (!img) return;
        try {
          var imgs = JSON.parse(swatch.getAttribute('data-all-images'));
          var src = imgs[1] || imgs[0];
          if (src) {
            img.removeAttribute('srcset');
            img.src = src;
          }
        } catch (err) {}
      }, 0);
    }
  });

  /* Filters, sorting and infinite scroll replace grid items: keep new items in sync. */
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      syncButtons();
      if (view === 'studio') syncSliders(false);
    });
  }).observe(root, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
